import TopBar from "../../components/topBar/topBar";
import BookIcon from './icons/book.svg';
import ArchiveIcon from './icons/archive.svg';
import ZborPrimIcon from './icons/zbor_prim.svg';
import ZborSecIcon from './icons/zbor_sec.svg';
import WebIcon from './icons/web.svg';
import PeriodIcon from './icons/period.svg';
import StudyIcon from './icons/study.svg';
import { Link } from "react-router-dom";

const TYPES = [
    { icon: BookIcon,     label: "Monografia",  state: 1 },
    { icon: ZborPrimIcon, label: "Zborník",      state: 2 },
    { icon: ZborSecIcon,  label: "Zborník",      state: 3 },
    { icon: StudyIcon,    label: "Štúdia",       state: 4 },
    { icon: PeriodIcon,   label: "Periodikum",   state: 5 },
    { icon: WebIcon,      label: "Internet",     state: 6 },
    { icon: ArchiveIcon,  label: "Dokument",     state: 7 },
];

function SelectBookType({ setPageState, success, setSuccess }) {
    return (
        <div className="min-h-screen">
            <TopBar logo={true} />
            <div className="mx-auto max-w-5xl px-4 sm:px-6 py-10">

                <Link
                    to="/dashboard"
                    className="group mb-8 -ml-1 inline-flex items-center gap-2 text-sm font-light text-mainDark/40 transition-colors duration-200 hover:text-mainDark"
                >
                    <svg className="h-4 w-4 transition-transform duration-200 group-hover:-translate-x-1" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="M19 12H5M12 5l-7 7 7 7" />
                    </svg>
                    Go Back
                </Link>

                <h1 className="mb-8 text-2xl font-light text-mainDark">Select book type</h1>

                {success && (
                    <div className="mb-6 flex items-center justify-between rounded-2xl border border-green-200 bg-green-50 px-5 py-3 text-sm text-green-700">
                        New entry added successfully
                        <button type="button" onClick={() => setSuccess(false)} className="ml-4 text-green-500 hover:text-green-700 transition-colors duration-200">✕</button>
                    </div>
                )}

                <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
                    {TYPES.map(({ icon, label, state }) => (
                        <button
                            key={state}
                            type="button"
                            onClick={() => setPageState(state)}
                            className="group flex flex-col items-center gap-4 rounded-2xl border border-mainDark/30 bg-mainWhite p-8 shadow-result transition-all duration-200 hover:shadow-result-hover hover:-translate-y-0.5 active:translate-y-0 cursor-pointer"
                        >
                            <img src={icon} alt="book icon" className="h-10 w-10 opacity-60 transition-opacity duration-200 group-hover:opacity-100" />
                            <span className="text-base font-light text-mainDark uppercase tracking-wide text-center">{label}</span>
                        </button>
                    ))}
                </div>

            </div>
        </div>
    );
}

export default SelectBookType;
